/**
 * @ngdoc service
 * @name cbl.telepass.wa.directive:tlpsProposta
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function() {
  angular.module('cbl.telepass.wa').service('TlpsDefinizioneSrvc', [
    '$http',
    'TlpsMessaggiFctr',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    function($http, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;

      var self = this;

      /*
       * -------------------------------------
       *           PROMISE SERVIZI REST
       * -------------------------------------
       */

      /**
       * @ngdoc method
       * @name promiseRecuperaContiCorrenti
       * @methodOf cbl.telepass.wa.directive:TlpsPropostaSrvc
       * @description Effettua una chiamata http per recuperare i conti correnti dell'ndg
       * @return {Promise} - Ritorna una promise contenente la lista dei conti correnti
       */
      this.promiseRecuperaContiCorrenti = function(ndg) {
        return this.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.CONTOCORRENTE.RICERCA_CONTICORRENTE,
          params: ndg
        });
      };

      this.promiseRecuperaModalitaRitiro = function(codProdotto, settore) {
        var qryParams = {
          settore: settore,
          canale: 'BRIO_FILIALE',
          prodotto: codProdotto
        };

        return this.$http({
          method: 'GET',
          url:
            CONSTANTS.REST_ROOT +
            CONSTANTS.REST.CONFIGURAZIONI.RECUPERA_MODALITA_RITIRO,
          data: {},
          params: qryParams
        });
      };
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsProposta/tlpsDefinizione/tlpsDefinizioneSrvc.js
// module id = 29
// module chunks = 0